export default {"src":"/_next/static/media/bell-slash.3970676b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};